module.exports = __webpack_public_path__ + "static/media/Driver_image.0276338f.png";